import {useState, useEffect, useMemo, useCallback} from 'react';
import sdk from '@/sdk';
import * as store from '@/store';
import {GRAY_RELEASE_KEYS, initGray, initGrayBatch} from '@/grayRelease';
import {getMorphoService, serviceNames} from '@/rte/editor';


const {
    isInGrayPromise: isAigcInGray,
} = initGray(GRAY_RELEASE_KEYS.aigc);

const {
    isInGrayPromise: isAigcSelectionInGray,
} = initGray(GRAY_RELEASE_KEYS.aigcSelection);

const {
    isInGrayPromise: isAigcHeadingContinueInGray,
} = initGray(GRAY_RELEASE_KEYS.aigcHeadingContinue);


const aigcMenuOptions = [
    {key: GRAY_RELEASE_KEYS.aigcShengChengTuPian, action: 'shengChengTuPian'},
    {key: GRAY_RELEASE_KEYS.aigcSuoXie, action: 'suoXie'}, // 缩写
    {key: GRAY_RELEASE_KEYS.aigcKuoXie, action: 'kuoXie'}, // 扩写
    {key: GRAY_RELEASE_KEYS.aigcXuXie, action: 'xuXie'}, // 续写
];

const {
    isInGrayPromise: isAigcActionMenuInGray,
} = initGrayBatch(aigcMenuOptions.map(item => item.key));

export const useAigcConfig = (isKuShareMode?: string) => {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState({
        selectionButton: false,
        preAIMenu: false,
        headingContinue: false,
        showRelativeInfo: false,
    });
    const [actionMenuOptions, setActionMenuOptions] = useState({});

    useEffect(() => {
        async function getAigcWhites() {
            const result = await isAigcInGray();
            setOpen(!!result);
            const selectionResult = await isAigcSelectionInGray();
            const headingContinueResult = await isAigcHeadingContinueInGray();
            setOptions({
                selectionButton: !!selectionResult,
                preAIMenu: true, // AIGC插件 - 划选菜单是否前置可hover
                headingContinue: !!headingContinueResult,
                showRelativeInfo: true, // AIGC 4.0新版完成菜单
            });

            const menuOptions: {[key: string]: boolean|undefined|null} = {};
            const actionMenuInGray: any = await isAigcActionMenuInGray();
            aigcMenuOptions.forEach(item => {
                // 有可能undefined，如果undefined依然直接赋值，AI插件内部会按默认值走
                menuOptions[item.action] = actionMenuInGray[item.key];
            });
            const fixedMenuOptions = {
                zhuanHuanLiuChengTu: true, // 智能创作-转换流程图
                zhuanHuanFenLan: true, // 智能创作 - 划选转换分栏
                zhuanHuanLieBiao: true, // AI转换列表
                zhuanHuanBiaoGe: true, // 智能创作 - 划选转换表格
                zhuanHuanNaoTu: true, // 智能创作 - AI转换脑图
            };
            setActionMenuOptions({...menuOptions, ...fixedMenuOptions});
        }
        if (!isKuShareMode) {
            getAigcWhites();
        }
    }, [isKuShareMode]);

    const showGuideVal = !sdk.as.user?.settings.newGuide?.aigcGuideIsRead;
    const [showGuide, setShowGuide] = useState(showGuideVal);
    const completedGuide = useCallback(() => {
        sdk.as
            .updateNewGuide({
                aigcGuideIsRead: true,
            })
            .then(() => {
                setShowGuide(false);
            })
            .catch(err => console.error(err));
    }, []);

    function getSpaceKey() {
        const settingsData = sdk.as.user?.settings?.newSettings?.intelligent;
        if (!settingsData) {
            return;
        }
        // eslint-disable-next-line no-negated-condition
        if (!Object.keys(settingsData).includes('useSpaceKey')) {
            // 如果接口没有返回相关字段，则默认为用户不禁用space快捷键
            return false;
        } else {
            // 根据接口返回的字段
            return !settingsData.useSpaceKey;
        }
    }

    return useMemo(() => {
        return {
            enable: isKuShareMode ? false : open,
            showGuide: isKuShareMode ? false : showGuide,
            onCloseGuide: completedGuide,
            imageEnable: true,
            aigcOptions: { // 后续的详细配置，可以继续扩展
                ...options,
                actionMenuOptions,
            },
            spaceDisabled: true, // 是否禁用智能创作快捷键space
            enableNewGuide: true, // 默认=优化空行的输入引导&空白卡片推荐'分栏和模板
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps, max-len
    }, [isKuShareMode, completedGuide, open, showGuide, options, actionMenuOptions, getSpaceKey()]);
};
